// Flujo representativo del avance de los agentes "Kloud Pilot" conectados a Google Chat.
// status en nodo/edge: 'pending' (construido, falta conectar) | 'building' (en construcción) | ausente = en vivo.

const kloudPilotAgents = {
  key: 'estado-actual',
  label: 'Estado Actual',
  dotColor: '#00FF66',
  enabled: true,
  description: 'Router de Google Chat → agentes de Ventas e Inventario en vivo · Billing y Reports en progreso',
  nodes: [
    { id: 'google_chat', kind: 'trigger', label: 'Google Chat', sub: 'Espacio de trabajo KIO', position: { x: 0, y: 200 } },
    { id: 'chat_router', kind: 'process', label: 'chat-router 0.3.0', sub: 'Cloud Run · proyecto facturaciongcp', position: { x: 280, y: 200 } },

    { id: 'cx_agent', kind: 'external', label: 'CX Agent Studio', sub: 'Agente de Ventas (ex-Gema Gemini)', position: { x: 620, y: 40 } },
    { id: 'cx_datastore', kind: 'external', label: 'Datastore (GCS)', sub: 'Base de conocimiento de ventas', position: { x: 900, y: 40 } },

    { id: 'inventory_api', kind: 'process', label: 'Inventory API', sub: 'Azure Container Apps', position: { x: 620, y: 220 } },
    { id: 'azure_openai', kind: 'human', label: 'Azure OpenAI', sub: 'gpt-5-mini', position: { x: 900, y: 160 } },
    { id: 'bigquery_inv', kind: 'external', label: 'BigQuery', sub: 'Inventario vivo vectorizado · kloud-pilot', position: { x: 900, y: 280 } },

    { id: 'billing_agent', kind: 'decision', label: 'Agente de Billing', sub: 'Construido, pendiente de conectar al router', status: 'pending', position: { x: 620, y: 400 } },
    { id: 'reports_agent', kind: 'process', label: 'Agente de Reports', sub: 'Basado en acciones de Healthcenter', status: 'building', position: { x: 620, y: 520 } },
  ],
  edges: [
    { id: 'e1', source: 'google_chat', target: 'chat_router' },
    { id: 'e2', source: 'chat_router', target: 'cx_agent', label: 'sales' },
    { id: 'e3', source: 'cx_agent', target: 'cx_datastore' },
    { id: 'e4', source: 'chat_router', target: 'inventory_api', label: 'inventory · Bearer + Secret Manager' },
    { id: 'e5', source: 'inventory_api', target: 'azure_openai' },
    { id: 'e6', source: 'inventory_api', target: 'bigquery_inv', label: 'WIF sin llaves' },
    { id: 'e7', source: 'chat_router', target: 'billing_agent', label: 'billing (falta conectar)', status: 'pending' },
    { id: 'e8', source: 'chat_router', target: 'reports_agent', label: 'reports (en construcción)', status: 'building' },
  ],
  path: ['google_chat', 'chat_router', 'cx_agent', 'cx_datastore', 'inventory_api', 'azure_openai', 'bigquery_inv'],
};

export const kloudPilotAgentsProject = {
  key: 'kloud-pilot-agents',
  label: 'Kloud Pilot Agents · Google Chat',
  actions: [kloudPilotAgents],
};

// Resumen de avance mostrado como infografía encima del diagrama
export const kloudPilotAgentsStatus = [
  { label: 'Ventas (CX Agent Studio)', state: 'live', note: 'Migrado de Gemini Gem a CX Agent Studio con datastore GCS' },
  { label: 'Inventario (Azure + BigQuery)', state: 'live', note: 'Container App con gpt-5-mini, lee inventario vectorizado en BigQuery' },
  { label: 'Billing', state: 'pending', note: 'Agente construido, falta configurarlo en el chat-router' },
  { label: 'Reports', state: 'building', note: 'En construcción, basado en las acciones del Healthcenter' },
];

export const ALL_PROJECT_FLOWS = [kloudPilotAgentsProject];
